import { Box, Container, Typography } from "@mui/material";

const steps = [
  {
    title: "Choose Your City",
    desc: "Select your city to discover nearby places and services.",
    icon: "📍",
  },
  {
    title: "Browse by Category",
    desc: "Explore temples, hospitals, parks, malls and more.",
    icon: "🧭",
  },
  {
    title: "Explore Places",
    desc: "View details, ratings, location and timings instantly.",
    icon: "🏙️",
  },
  {
    title: "Visit or Contact",
    desc: "Get directions or contact the place with ease.",
    icon: "📞",
  },
];

const HowItWorks = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        py: { xs: 5, md: 7 },
        borderTop: "1px solid rgba(13,59,102,0.06)",
      }}
    >
      <Container>
        {/* ===== HEADER ===== */}
        <Box sx={{ mb: 4, maxWidth: 600 }}>
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.7rem", md: "2.2rem" },
              fontWeight: 800,
              color: "var(--color-neon, #0D3B66)",
              letterSpacing: "-0.4px",
            }}
          >
            How It{" "}
            <Box component="span" sx={{ color: "#F4D35E" }}>
              Works
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 1,
              color: "rgba(13,59,102,0.7)",
              fontSize: "0.95rem",
              lineHeight: 1.6,
            }}
          >
            Finding nearby places has never been easier. Just follow these
            simple steps.
          </Typography>
        </Box>

        {/* ===== STEPS (FLEXBOX ONLY) ===== */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: { xs: 2, md: 3 },
          }}
        >
          {steps.map((step, index) => (
            <Box
              key={index}
              sx={{
                flex: {
                  xs: "1 1 100%",
                  sm: "1 1 calc(50% - 16px)",
                  md: "1 1 calc(25% - 24px)",
                },
                backgroundColor: "#FFFDF7",
                borderRadius: 3,
                p: { xs: 2.5, md: 3 },
                border: "1px solid rgba(13,59,102,0.08)",
                boxShadow: "0 10px 24px rgba(0,0,0,0.06)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: { md: "translateY(-6px)" },
                  boxShadow: "0 18px 40px rgba(13,59,102,0.18)",
                },
              }}
            >
              {/* ICON */}
              <Box
                sx={{
                  fontSize: "2.2rem",
                  mb: 1.5,
                }}
              >
                {step.icon}
              </Box>

              {/* TITLE */}
              <Typography
                sx={{
                  fontWeight: 700,
                  color: "var(--color-neon, #0D3B66)",
                  fontSize: "1.05rem",
                  mb: 0.6,
                }}
              >
                {step.title}
              </Typography>

              {/* DESC */}
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  color: "rgba(13,59,102,0.7)",
                  lineHeight: 1.5,
                }}
              >
                {step.desc}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default HowItWorks;
